import React from 'react';
import { Outlet } from 'react-router-dom';

import '../../Mobile.css';
function Patient() {

  return (
    <>
      <Outlet />
    </>
  );
}

export default Patient